import { sendWebsocketMessage } from '../../../../../App';
/**
 * this button was created with the intent that if there appears to be serious issues between TU and the broker,
 * to disconnect (or reconnect once disconnected) TU from the broker.
 * @param {boolean} killTrading whether we are setting kill trading to true or to false
 */
export function setKillTrading(killTrading) {
    const msg = {
        kill: killTrading,
        messageType: "killTrading",
    };
    sendWebsocketMessage(msg);
}